export default {
  currentUser: null,
  breadcrumbs: [],
  tokenCoupen: [],
  snackBar: {
    text: '',
    color: '',
    show: false,
    multiLine: false,
    actionText: null,
    actionCallback: null,
  },
  drawer: true,
  helpMenu: false,
  season: sessionStorage.getItem('season') ? JSON.parse(sessionStorage.getItem('season')) : null,
  videoFeatures: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js